import React, { useEffect, useState } from "react";
import Modal from "react-modal";

import "./style.scss";
import "./new-modal.scss";

Modal.setAppElement("#modal");
const ModalContainer = ({
    width,
    height,
    children,
    className,
    confirm,
    visible,
    skipClose,
    open,
    closeModal,
    wrapClassName = "",
    modalClassName = "",
	overlayClassName = "",
	  ...rest
}) => {

	const [modalIsOpen, setModalIsOpen] = useState(false);

	useEffect(() => {
		if(open) {
			openModal();
		} else {
			closeModalAction(true);
		}
	}, [open]);


	const openModal = () => {
		setModalIsOpen(true);
	};

	const closeModalAction = (initial) => {
		setModalIsOpen(false);
		closeModal(initial);
	};

	let customStyles = {content : {}, overlay: {}};
	if(width) {
		customStyles.content.width = width
		customStyles.content.height = height
	}

	return (
		<Modal
			parentSelector={() => document.querySelector('#modal')}
			isOpen={modalIsOpen}
			onRequestClose={() => closeModalAction()}
			style={customStyles}
			closeTimeoutMS={0}
			overlayClassName={`paylixecommerce-overlay ${overlayClassName}`}
			className={`paylixecommerce-modal ${className?className:''} ${confirm?'confirm':''} ${visible ?'visible':''}`}
			shouldCloseOnOverlayClick={!skipClose}
			wrapClassName={wrapClassName} modalClassName={modalClassName}
			{...rest}
		>
			{!skipClose && <div className="paylixecommerce-modal-close" onClick={() => closeModalAction()} >
				<i className="fa-light fa-times" style={{ color: "var(--black9)", fontSize: "1.25rem" }} />
			</div>}
			{children}
		</Modal>
	);
}

export default ModalContainer;
